export default "__VITE_ASSET__D9t4UwUI__"